import './styles.scss'

import React from 'react'
import { useActions, useValues } from 'kea'

import I18n from 'lib/i18n'

import logic from './logic'

const FavoriteButton = () => {
  const { isInWishlist, isToggling } = useValues(logic)
  const { toggleWishlistStatus } = useActions(logic)

  return (
    <div className='favorite-button'>
      <span className={`favlink-nojs class-button${isToggling ? ' toggling' : ''}`} onClick={toggleWishlistStatus}>
        <img className='heart-icon' alt='favorite button' src='/assets/icons/heart.png' width={16} height={16} />
        {isInWishlist ? (
          <span>{I18n.t('profiles.profile_layout.remove_fav')}</span>
        ) : (
          <span>{I18n.t('profiles.profile_layout.add_fav')}</span>
        )}
      </span>
    </div>
  )
}

export default FavoriteButton
